<template>
  <div id="print-report">
    <HeaderPrint />
    <router-view />
  </div>
</template>
<script>
import HeaderPrint from "@/components/common/header-print";

export default {
  components: {
    HeaderPrint,
  },
  watch: {
    $route(val) {
      const prefix =
        this.$prefix() === "colab" ? "Collaborator" : "Administrator";

      if (val.name === `${prefix}AffiliatesPayments`) {
        if (prefix === "colab") {
          if (this.$permission("105")) {
            this.$router.push({ name: `${prefix}AffiliatesPaymentsPay` });
          } else if (this.$permission("106")) {
            this.$router.push({ name: `${prefix}AffiliatesPaymentsHistoric` });
          }
        } else {
          this.$router.push({ name: `${prefix}AffiliatesPaymentsPay` });
        }
      }
    },
  },
};
</script>
